/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSpecialityResultModel } from '../../models/system-speciality-result-model';

export interface AnonymousSystemSpecialitiesGet$Params {
  systemOrganizationFhirId?: string;
}

export function anonymousSystemSpecialitiesGet(http: HttpClient, rootUrl: string, params?: AnonymousSystemSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SystemSpecialityResultModel>>> {
  const rb = new RequestBuilder(rootUrl, anonymousSystemSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.query('systemOrganizationFhirId', params.systemOrganizationFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<SystemSpecialityResultModel>>;
    })
  );
}

anonymousSystemSpecialitiesGet.PATH = '/Anonymous/SystemSpecialities';
